var map = {
	"./AD.png": "4f01",
	"./AE.png": "ea19",
	"./AF.png": "94d0",
	"./AG.png": "d158",
	"./AI.png": "d66a",
	"./AL.png": "c2a9",
	"./AM.png": "be2c5",
	"./AN.png": "f24d",
	"./AO.png": "a9df",
	"./AR.png": "9607",
	"./AS.png": "7d92",
	"./AU.png": "dcef",
	"./AUT.png": "ada38",
	"./AW.png": "65a9",
	"./AX.png": "7739",
	"./AZ.png": "57067",
	"./BA.png": "6659",
	"./BB.png": "0185",
	"./BD.png": "f7b9",
	"./BEL.png": "e90a",
	"./BF.png": "2e64",
	"./BGR.png": "704a",
	"./BH.png": "873d",
	"./BI.png": "659f",
	"./BJ.png": "da07",
	"./BM.png": "d1a7",
	"./BN.png": "4fbf",
	"./BO.png": "f587",
	"./BR.png": "7683",
	"./BS.png": "f4d4",
	"./BT.png": "2ae3",
	"./BV.png": "170c",
	"./BW.png": "9542",
	"./BY.png": "ed58",
	"./BZ.png": "1b2d",
	"./CA.png": "856b",
	"./CD.png": "f1f5",
	"./CF.png": "ce5e",
	"./CG.png": "b2b0",
	"./CHE.png": "94be",
	"./CI.png": "88e1",
	"./CK.png": "07c2",
	"./CL.png": "c65a",
	"./CM.png": "a814",
	"./CN.png": "5064",
	"./CO.png": "8d30",
	"./CR.png": "b889",
	"./CU.png": "3dd8",
	"./CV.png": "c3c2",
	"./CW.png": "61c3",
	"./CYP.png": "cf25",
	"./CZE.png": "1473",
	"./DEU.png": "4758",
	"./DJ.png": "4139",
	"./DM.png": "8019",
	"./DNK.png": "ea4a",
	"./DO.png": "8d02",
	"./DZ.png": "2fd4",
	"./EC.png": "9d38",
	"./EG.png": "3738",
	"./EH.png": "b238",
	"./ER.png": "61b6",
	"./ESP.png": "274b",
	"./EST.png": "a756",
	"./ET.png": "2de8",
	"./EU.png": "fb61",
	"./FIN.png": "faf2",
	"./FJ.png": "6a01",
	"./FK.png": "3d34",
	"./FM.png": "f6e1",
	"./FRA.png": "4a4a",
	"./GA.png": "9cc8",
	"./GBR.png": "51f8",
	"./GD.png": "932c",
	"./GE.png": "269a",
	"./GG.png": "f853",
	"./GH.png": "7064",
	"./GI.png": "8a2f",
	"./GM.png": "a4a6",
	"./GN.png": "9286",
	"./GP.png": "d25c",
	"./GQ.png": "c069",
	"./GRC.png": "c088",
	"./GT.png": "90ac",
	"./GU.png": "cab9",
	"./GW.png": "06e7",
	"./GY.png": "09ba",
	"./HK.png": "b286",
	"./HN.png": "ca8e",
	"./HRV.png": "da9c",
	"./HT.png": "a849",
	"./HUN.png": "d47e",
	"./ID.png": "ba3a",
	"./IL.png": "9fe7",
	"./IM.png": "2a99",
	"./IN.png": "4c66",
	"./IQ.png": "78fa",
	"./IR.png": "c100",
	"./IRL.png": "af65",
	"./ISL.png": "e669",
	"./ITA.png": "131a",
	"./JE.png": "cad9",
	"./JM.png": "7da9",
	"./JO.png": "119b",
	"./JP.png": "dceb",
	"./KE.png": "a599",
	"./KG.png": "6c65",
	"./KH.png": "d79b",
	"./KI.png": "2f5e",
	"./KM.png": "b3cf",
	"./KN.png": "5c09",
	"./KP.png": "103c",
	"./KR.png": "27e5",
	"./KW.png": "53b6",
	"./KY.png": "da8c",
	"./KZ.png": "10cf",
	"./LA.png": "1013",
	"./LB.png": "4128",
	"./LC.png": "f1f7",
	"./LI.png": "4032",
	"./LK.png": "2405",
	"./LR.png": "384d",
	"./LS.png": "89e5",
	"./LTU.png": "5d85",
	"./LUX.png": "78b9",
	"./LVA.png": "65b7",
	"./LY.png": "683e",
	"./MA.png": "33ea",
	"./MC.png": "77ee",
	"./MD.png": "e200",
	"./ME.png": "6a12",
	"./MF.png": "3feb",
	"./MG.png": "0f83",
	"./MK.png": "70b5",
	"./ML.png": "ba4a",
	"./MLT.png": "b990",
	"./MM.png": "3892",
	"./MN.png": "bdcb",
	"./MO.png": "92d6",
	"./MR.png": "94d9",
	"./MS.png": "6762",
	"./MU.png": "04ea",
	"./MV.png": "6710",
	"./MW.png": "6e78",
	"./MX.png": "6eb9",
	"./MY.png": "9b31",
	"./MZ.png": "92cd",
	"./NA.png": "0b5c",
	"./NC.png": "bff8",
	"./NE.png": "586b",
	"./NF.png": "c07d",
	"./NG.png": "420e",
	"./NI.png": "2aeb",
	"./NLD.png": "72b4",
	"./NOR.png": "ffbc",
	"./NP.png": "bac1",
	"./NR.png": "1051",
	"./NZ.png": "5bcc",
	"./OM.png": "8b12",
	"./PA.png": "dd61",
	"./PE.png": "9cc89",
	"./PF.png": "3b8e",
	"./PG.png": "66b8",
	"./PH.png": "0e4c",
	"./PK.png": "87d5",
	"./POL.png": "57cc",
	"./PR.png": "49b5",
	"./PRT.png": "5920",
	"./PS.png": "2ede",
	"./PW.png": "f0e6",
	"./PY.png": "d619",
	"./QA.png": "0fcd",
	"./ROU.png": "04bb",
	"./RU.png": "fb02",
	"./RW.png": "dea8",
	"./SA.png": "2665",
	"./SB.png": "f47c",
	"./SC.png": "b2fb",
	"./SD.png": "4869",
	"./SG.png": "9ec4",
	"./SH.png": "632d",
	"./SL.png": "dccd",
	"./SM.png": "c880",
	"./SN.png": "c5af",
	"./SO.png": "9a33",
	"./SR.png": "2127",
	"./SRB.png": "b977",
	"./ST.png": "6e84",
	"./SV.png": "2b8e",
	"./SVK.png": "0a60",
	"./SVN.png": "c95c",
	"./SWE.png": "8c1a",
	"./SY.png": "7322",
	"./SZ.png": "2295",
	"./TC.png": "adc0",
	"./TD.png": "d059",
	"./TG.png": "41399",
	"./TH.png": "aeae",
	"./TJ.png": "22ac",
	"./TL.png": "d84d",
	"./TM.png": "e59c",
	"./TN.png": "f9e0",
	"./TO.png": "a9e5",
	"./TR.png": "1ea5",
	"./TT.png": "7447",
	"./TV.png": "d1cc",
	"./TW.png": "fdbc",
	"./TZ.png": "2ae0",
	"./UA.png": "7885",
	"./UG.png": "9c53",
	"./US.png": "7770",
	"./UY.png": "c7b1",
	"./UZ.png": "525f",
	"./VC.png": "4fad",
	"./VE.png": "11ad",
	"./VG.png": "ff76",
	"./VI.png": "2a66",
	"./VN.png": "d842",
	"./VU.png": "79da",
	"./WS.png": "7fc7",
	"./YE.png": "9c55",
	"./ZA.png": "28db",
	"./ZM.png": "0ce2",
	"./ZW.png": "d699",
	"./un.png": "cda1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";